import { memo as e } from "react";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { useTranslation as r } from "react-i18next";
var i = {
	cardHeaderWrapper: "_cardHeaderWrapper_ic5ne_1",
	cardHeaderInnerWrapper: "_cardHeaderInnerWrapper_ic5ne_6",
	breadcrumbIcon: "_breadcrumbIcon_ic5ne_19",
	cardEventLinkWrapper: "_cardEventLinkWrapper_ic5ne_27",
	cardEventLink: "_cardEventLink_ic5ne_27",
	cardHeaderContentContainer: "_cardHeaderContentContainer_ic5ne_61",
	cardHeaderTextWrapper: "_cardHeaderTextWrapper_ic5ne_82",
	dropdownTitleWrapper: "_dropdownTitleWrapper_ic5ne_106",
	dropdownTitle: "_dropdownTitle_ic5ne_106"
}, a = ({ articleType: e = null, breadcrumb: a, displayTitle: o, title: s }) => {
	let { t: c } = r(), l = "";
	e?.includes("picks") ? l = "CX_TIPS_HEADER_PREFIX" : e?.includes("insights") ? l = "CX_NEWS_HEADER_PREFIX" : e?.includes("betting-guide") && (l = "CX_BETTING_GUIDES_HEADER_PREFIX");
	let u = l ? c(l) : "", d = o || s, f = u && u !== l ? `${u} ${d}` : d;
	return /* @__PURE__ */ t("div", {
		className: i.cardHeaderWrapper,
		"data-testid": "card-header",
		children: /* @__PURE__ */ n("div", {
			className: i.cardHeaderInnerWrapper,
			"data-testid": "card-breadcrumb-div",
			children: [!!a && /* @__PURE__ */ n("div", {
				className: i.cardEventLinkWrapper,
				children: [/* @__PURE__ */ t("span", {
					className: i.breadcrumbIcon,
					children: /* @__PURE__ */ t("svg", {
						fill: "currentColor",
						height: "100%",
						preserveAspectRatio: "xMidYMid",
						viewBox: "0 0 6 12",
						width: "100%",
						xmlns: "http://www.w3.org/2000/svg",
						children: /* @__PURE__ */ t("path", {
							clipRule: "evenodd",
							d: "M0.409017 6.69364C0.0361104 6.30639 0.0361104 5.6936 0.409017 5.30635L4.4669 1.09239C4.69078 0.859913 5.06296 0.859913 5.28683 1.09239C5.49907 1.31279 5.49907 1.66156 5.28683 1.88196L1.32131 6L5.28683 10.118C5.49907 10.3384 5.49907 10.6872 5.28683 10.9076C5.06296 11.1401 4.69078 11.1401 4.4669 10.9076L0.409017 6.69364Z",
							fillRule: "evenodd"
						})
					})
				}), /* @__PURE__ */ t("a", {
					className: `${i.cardEventLink} ogm-card-header__breadcrumb`,
					"data-testid": "card-breadcrumb",
					href: a.url,
					title: a.name,
					children: a.name
				})]
			}), /* @__PURE__ */ t("div", {
				className: i.cardBodyWrapper,
				id: "card-header",
				children: /* @__PURE__ */ t("div", {
					className: i.cardHeaderContentContainer,
					children: /* @__PURE__ */ t("div", {
						className: `${i.cardHeaderTextWrapper} ogm-card-header__title`,
						children: /* @__PURE__ */ t("h1", {
							className: i.cardTitle,
							"data-testid": "card-title",
							children: f
						})
					})
				})
			})]
		})
	});
}, o = e(a);
//#endregion
export { a as ParentLinkHeader, o as default };
